import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import Wrapper from '../components/wrapper'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import CustomCrmForm from '../components/app-form/CustomCrmForm'
import { CustomCrmBigIcon, BackIcon } from '../components/app-icon/Icons'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import CustomizeAll from '../components/сustomize-all/'
import AppStepper from '../components/app-stepper'
import { ButtonContained } from '../components/app-button/button'
import TraficLight from '../components/traficLight'
import LicenseExpired from '../components/payment/LicenseExpired'
import { ActionsForUsing } from '../components/payment/LicenseExpired'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 940,
    width: '100%',
  },
  navigation: {
    display: 'flex',
    margin: '10px 0 0 0',
    padding: '0 24px',
  },
  content: {
    maxWidth: 630,
    width: '100%',
    marginTop: 32,
  },
  title: {
    position: 'relative',
    padding: '27px 24px 0 14px',
  },
  description: {
    padding: '0 85px 85px 60px',
  },
  chanelIcon: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 24,
    right: 40,
    width: 96,
    height: 44,
    backgroundColor: '#ffffff',
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    marginRight: 5,
  },
  viewList: {
    margin: 0,
    padding: 0,
  },

  list: {
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  link: {
    textDecoration: 'none',
  },
  toolbarInner: {
    padding: 0,
  },
  extendedIcon: {
    marginRight: 5,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  amoWrapper: {
    width: '628px',
  },
  crmDescription: {
    width: '343px',
  },
  crmDescriptionText: {
    fontSize: '12px',
    fontWeight: '600',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '1.5',
    letterSpacing: '2px',
  },
  crmDescriptionSmall: {
    marginTop: '20px',
    fontSize: '14px',
  },
  error: {
    paddingTop: '20px',
    fontSize: '12px',
    color: '#ff4e44',
  },
  finishBtn: {
    display: 'block',
    marginTop: '20px',
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Google Analytics \nнастроен',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class CustomCrm extends Component {
  state = {
    activeStep: 4,
    isFetching: false,
    error: '',
    site: window.state.site,
    dataSource: window.state.dataSource,
    user: window.state.user,
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/crm/custom/create'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })
      .then(status)
      .then(json)
      .then(data => {
        this.setState({
          isFetching: false,
        })
        if (data.error) {
          this.setState({ error: data.error })
        } else {
          if (isNaN(state.step)) {
            state.step = 1
          }
          location.href = '/crm/custom?step=' + (parseInt(state.step) + 1)
        }
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  render() {
    const { classes } = this.props
    const { site, user } = this.state

    const steps = getSteps()

    return (
      <Fragment>
        {user.wizard_finished_at && (
          <LicenseExpired>
            <ActionsForUsing />
          </LicenseExpired>
        )}
        <main className={classes.pageTemplate}>
          <AppBar
            position="static"
            color="inherit"
            elevation={0}
            style={{ padding: '24px' }}
          >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />

              <a className={classes.container} href={`http://${site.url.replace(/(http|https):\/\//is, '')}`} target="_blank">
                <div className={classes.siteIcon}>S</div>
                <ul className={classes.info}>
                  <Typography component="li" variant="body1">
                    {site.url}
                  </Typography>
                  <Typography component="li" variant="overline">
                    {site.name}
                  </Typography>
                </ul>
              </a>

              {user.wizard_finished_at && <TraficLight />}
            </Toolbar>
          </AppBar>
          <CustomizeAll />

          <article className={classes.wizardRow}>
            <LeftNavigationDashboard />
            {!state.wizardFinishedAt ? (
              <div style={{ width: 200, marginRight: 40 }}>
                <AppStepper activeStep={this.state.activeStep} steps={steps} />
                <a
                  href="/wizard/calltracking/settings"
                  className={classes.finishBtn}
                >
                  <ButtonContained full={true} color="primary" text="Далее" />
                </a>
              </div>
            ) : (
              ''
            )}

            <div className={classes.amoWrapper}>
              <Wrapper shadow={4}>
                <header className={classes.title}>
                  <Typography
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: 10,
                      fontWeight: 'normal',
                      fontStyle: 'normal',
                      fontStretch: 'normal',
                      lineHeight: 1.6,
                      letterSpacing: 0.8,
                      color: '#000000',
                    }}
                  >
                    <a
                      href={
                        !state.wizardFinishedAt
                          ? '/wizard/crm/settings'
                          : '/crm'
                      }
                      className={classes.back}
                    >
                      <BackIcon width={24} height={24} stroke={'#000000'} />
                    </a>
                    Подключение импорта из CRM
                  </Typography>

                  <div className={classes.chanelIcon}>
                    <CustomCrmBigIcon height={33} />
                  </div>
                </header>
                <section className={classes.description}>
                  <div className={classes.crmDescription}>
                    <h2 className={classes.crmDescriptionText}>
                      ПОДКЛЮЧАЕМ CRM
                    </h2>
                    <div className={classes.crmDescriptionSmall}>
                      <a href="/help/podklyuchenie-crm" target="_blank">
                        Перед подключением CRM системы, рекомендуем ознакомиться
                        с инструкцией
                      </a>
                    </div>
                    {this.state.error ? (
                      <div className={classes.error}>{this.state.error}</div>
                    ) : (
                      ''
                    )}

                    <CustomCrmForm
                      onSubmit={this.handleSubmit}
                      isFetching={this.state.isFetching}
                      error={this.state.error}
                      initialValues={
                        state.account && {
                          name: state.account.name,
                          destination: state.account.import_destination,
                          hash: state.account.hash,
                        }
                      }
                    />
                  </div>
                </section>
              </Wrapper>
            </div>
          </article>
        </main>
      </Fragment>
    )
  }
}

export default withStyles(styles)(CustomCrm)
